import ListEntitiesItem from "components/ListEntitiesItem";
import ListEntitiesItemDescription from "components/ListEntitiesItem/Description";
import ListEntitiesItemTitle from "components/ListEntitiesItem/Title";
import Box from "ds/components/Box";
import { useDrawerVisibilityForId } from "ds/components/DrawerNew/useDrawerVisibilityForId";
import useTypedContext from "hooks/useTypedContext";
import { VcsProvider } from "types/generated";
import { AccountContext } from "views/AccountWrapper";

import {
  COLUMN_GAP,
  COLUMN_ORDER,
  ORIGIN_INTEGRATION_DESCRIPTION,
  ORIGIN_INTEGRATION_DETAILS_DRAWER_ID,
  ORIGIN_INTEGRATION_NAME,
} from "../../shared/VcsList/constants";
import VCSProviderIcon from "../../shared/VcsShared/components/ProviderIcon";
import VCSIntegrationsOriginDropdownActions from "./OriginDropdownActions";

type VCSIntegrationsOriginListItemProps = {
  onEdit: () => void;
  onShowDetails: () => void;
  onDelete: () => void;
};

const VCSIntegrationsOriginListItem = ({
  onEdit,
  onShowDetails,
  onDelete,
}: VCSIntegrationsOriginListItemProps) => {
  const isDetailsDrawerVisible = useDrawerVisibilityForId(ORIGIN_INTEGRATION_DETAILS_DRAWER_ID);
  const { viewer } = useTypedContext(AccountContext);

  return (
    <ListEntitiesItem
      direction="row"
      align="center"
      justify="between"
      grid
      gridTemplate={COLUMN_ORDER}
      gap={`0 ${COLUMN_GAP}`}
      isActive={isDetailsDrawerVisible}
      role="row"
    >
      <Box gap="large" role="rowheader">
        <VCSProviderIcon provider={VcsProvider.Origin} tile />

        <Box grow="1">
          <Box direction="column" fullWidth>
            <ListEntitiesItemTitle title={ORIGIN_INTEGRATION_NAME} titleVariant="p-body2" />

            <Box direction="row" align="start" fullWidth>
              <ListEntitiesItemDescription
                noPadding
                description={ORIGIN_INTEGRATION_DESCRIPTION}
                tooltipMode
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box shrink="0" role="cell">
        <VCSIntegrationsOriginDropdownActions
          onShowDetails={onShowDetails}
          onEdit={onEdit}
          onDelete={onDelete}
          canManageVCSIntegrations={viewer.admin}
        />
      </Box>
    </ListEntitiesItem>
  );
};

export default VCSIntegrationsOriginListItem;
